export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '育体科技',

    /** 公司名称 */
    name: '北京育体科技有限公司',
    /** 公司微信 */
    wechat: 'lanqiuwin888',
    /** 公司邮箱 */
    email: 'wenjiabing@dele.com',
    /** 公司手机 */
    phone: '17164178331',
    /** 公司电话 */
    tel: '',
    /** 公司地址 */
    address: '北京市石景山区八大处路49号院6号楼五层5186号',
    /** 备案号 */
    keepOnRecordIcp: '京ICP备2023025033号-1',

    /** 百度地图相关信息 */
    BDMapInfo: {
        longitude: 116.20,
        latitude: 39.94,
        title: '点石商务公园',
        address: '北京市石景山区八大处路49号院6号楼五层5186号'
    }
}


// WEBPACK FOOTER //
// ./src/config/index.js